"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var orders_1 = require("./orders");
var base_1 = require("./base");
var service_1 = require("../service");
var settings_1 = require("../settings");
var _ = require("lodash");
/**
 * General namespace for Users function
 */
var Users;
(function (Users) {
    /**
     * Request a token (via e-mail) for a user
     *
     * @param  {string}  emailAddress the e-mail adres of the user to request the token for
     * @return {Promise}              A promise that is fulfilled when the EVA Core service responds
     */
    function requestResetPassword(emailAddress) {
        var service = new service_1.EVAService("RequestPasswordResetToken");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            EmailAddress: emailAddress
        };
        return service.call(requestData);
    }
    Users.requestResetPassword = requestResetPassword;
    /**
     * Reset a user password using a token that was received in an e-mail
     *
     * @param  {string}  newPassword the new password
     * @param  {string}  token       the token to be used for this reset
     * @return {Promise}             A promise that is fulfilled when the EVA Core service responds
     */
    function resetPassword(newPassword, token) {
        var service = new service_1.EVAService("ResetUserPassword");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            NewPassword: newPassword,
            Token: token
        };
        return service.call(requestData);
    }
    Users.resetPassword = resetPassword;
})(Users = exports.Users || (exports.Users = {}));
/**
 * Create a customer
 *
 * @param  {EVA.Core.Services.CustomerDto} customer A customer Dto object containing the customer details
 * @param  {IEVACreateCustomer}                  options  Creation options for the user account
 * @return {Promise<any>}                                 A promise that is fulfilled when the EVA Core service responds
 */
function createCustomer(customer, options) {
    return new Promise(function (resolve, reject) {
        var service = new service_1.EVAService("CreateCustomer");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            User: customer
        };
        if (options) {
            requestData.NoAccount = options.noAccount;
            requestData.AutoLogin = options.autoLogin;
        }
        service.call(requestData)
            .then(function (serviceResult) {
            // console.log( "[CREATECUSTOMER] Response", serviceResult );
            // EVA.Core.Services.CreateCustomerResults
            //  * CreatedCustomer = 0
            //  * InvalidEmail = 1
            //  * UsedIncompleteAccount = 2
            //  * EmailAlreadyInUse = 3
            //
            if (serviceResult.response.Result === 0 || serviceResult.response.Result === 2) {
                resolve(serviceResult.response.User);
            }
            else {
                reject(serviceResult.response.Result);
            }
        })
            .catch(function (error) {
            // console.error( "[CREATECUSTOMER] Error", error );
            reject(error);
        });
    });
}
/**
 * Create a customer together with a company
 *
 * @param  {EVA.Core.Services.CreateCustomerWithCompany} request A create customer with company dto object
 * @return {Promise<any>}                                        A promise that is fulfilled when the EVA Core service responds
 */
function createCustomerWithCompany(requestData) {
    return new Promise(function (resolve, reject) {
        var service = new service_1.EVAService("CreateCustomerWithCompany");
        service.call(requestData)
            .then(function (serviceResult) {
            resolve(serviceResult.response);
        })
            .catch(function (error) {
            reject(error);
        });
    });
}
/**
 * Provides authentication to EVA
 *
 * id is authentication
 */
var LoggedInUser = /** @class */ (function (_super) {
    __extends(LoggedInUser, _super);
    function LoggedInUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoggedInUser.checkEmailAddressAvailability = function (emailAddress) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("CheckEmailAddressAvailability");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                EmailAddress: emailAddress
            };
            service.call(requestData)
                .then(function (serviceResult) {
                if (!serviceResult.response.IsAvailable) {
                    reject(serviceResult.response);
                }
                else {
                    resolve(serviceResult.response);
                }
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    LoggedInUser.checkNicknameAvailability = function (nickname) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("CheckNicknameAvailability");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {
                Nickname: nickname
            };
            service.call(requestData)
                .then(function (serviceResult) {
                if (!serviceResult.response.IsAvailable) {
                    reject(serviceResult.response);
                }
                else {
                    resolve(serviceResult.response);
                }
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    /**
     * Register a new customer and autologin
     *
     * @param  {any}            customer EVA.Core.Services.CustomerDto but only EmailAddress
     * @return {Promise<any>}   A promise that is fulfilled when the EVA Core service responds
     */
    LoggedInUser.register = function (customer, autoLogin, noAccount) {
        if (autoLogin === void 0) { autoLogin = true; }
        if (noAccount === void 0) { noAccount = false; }
        var options = {
            autoLogin: autoLogin,
            noAccount: noAccount
        };
        return new Promise(function (resolve, reject) {
            createCustomer(customer, options)
                .then(function (user) {
                resolve({
                    AuthenticationToken: user.AuthenticationToken,
                    User: user
                });
            })
                .catch(reject);
        });
    };
    /**
     * Register a new customer with company
     *
     * @param  {EVA.Core.Services.CreateCustomerWithCompany} request    Create a customer with company request
     * @return {Promise<any>}                                           A promise that is fulfilled when the EVA Core service responds
     */
    LoggedInUser.registerWithCompany = function (request) {
        return new Promise(function (resolve, reject) {
            createCustomerWithCompany(request)
                .then(function (response) {
                resolve(response);
            })
                .catch(reject);
        });
    };
    /**
     * Retrieve the company details for a user
     * @return {Promise<EVA.Core.CompanyDto>}
     */
    LoggedInUser.getCompanyForUser = function (userId) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetCompanyForUser");
            var requestData = {
                UserID: userId,
            };
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(_.get(serviceResult, "response.Result"));
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    /**
     * Method to update a company that belongs to the logged-in user
     *
     * @param {EVA.Core.CompanyDto} company The company to update
     * @returns {Promise<boolean>} Promise that returns true if update was successful
     */
    LoggedInUser.updateCompanyForUser = function (userId, company) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("UpdateCompanyForUser");
            var requestData = Object.assign(company, {
                UserID: userId,
                __response: undefined
            });
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(true);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    /**
     * Search for customers
     *
     * @param  {string}           query           The query to search on
     * @param  {number}           limit           The page size limit. Defaults to 15
     * @param  {number}           start           The item to start the list at. Defaults to 0 and is a 0-based index.
     * @return {Promise<any>}                     A promise that is fulfilled when the EVA Core service responds
     */
    LoggedInUser.searchUsers = function (options) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("SearchUsers");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            // EVA.Core.UserTypes
            //
            // None = 0,
            // Employee = 1,
            // Customer = 2,
            // Anonymous = 4,
            // Business = 8,
            // SuperUser = 17,
            // Migrated = 32,
            // Debtor = 64,
            // Incomplete = 128,
            // LimitedTrust = 256,
            // Tester = 512,
            //
            var requestData = {
                Types: 2,
                PageConfig: {
                    Limit: options.limit | 25,
                    Start: options.skip | 0
                }
            };
            if (options.query) {
                requestData.SearchQuery = options.query;
            }
            if (options.employeeId) {
                requestData.AssignedEmployeeID = options.employeeId;
            }
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(function (error) {
                // console.error( "[SEARCH:USERS] Error", error );
                reject(error);
            });
        });
    };
    /**
     * Retrieves and updates current user data
     * @return {Promise} A promise that is fulfilled when the EVA Core service responds
     */
    LoggedInUser.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {};
        return _super.prototype.fetch.call(this, "GetCurrentUser", requestData);
    };
    /**
     * @param  {any}                                  response Provide with body of the response to populate and set properly the data on CurrentUser
     * @return {EVA.Core.LoggedInUserDto}          The current LoggedInUserDto state
     */
    LoggedInUser.prototype.setData = function (response) {
        if (response === void 0) { response = {}; }
        // Set the current user data
        //
        this.data = response.User;
        if (this.data) {
            this.id = this.data.ID;
        }
        else {
            this.id = undefined;
        }
        /**
         * EVA.Core.AuthenticationResults
         *  NotAuthenticated = 0
         *  NotAuthorized = 1
         *  Authenticated = 2
         *  NeedsTwoStepAuthentication = 3
         *  NeedsOrganizationUnitID = 4
         */
        this.authentication = response.Authentication !== undefined ? response.Authentication : this.authentication;
        this.authenticationToken = response.AuthenticationToken !== undefined ? response.AuthenticationToken : this.authenticationToken;
        this.organisationUnits = response.OrganizationUnits !== undefined ? response.OrganizationUnits : this.organisationUnits;
        if (response.Authentication === undefined || response.Authentication === 2) {
            this.isEmployee = this.data && (this.data.Type & 1) !== 0;
            this.isCustomer = this.data && (this.data.Type & 2) !== 0;
            this.isAnonymous = !this.data || (this.data.Type & 4) !== 0;
        }
        else {
            this.isEmployee = false;
            this.isCustomer = false;
            this.isAnonymous = true;
        }
        return this.data;
    };
    /**
     * Return the current authentication token
     * @return {string} The current authentication token
     */
    LoggedInUser.prototype.getAuthenticationToken = function () {
        return this.authenticationToken;
    };
    /**
     * Perform a login using email adress and password, and optional additional
     * data
     *
     * @param  {string}  login        The email address or username (nickname) to login with
     * @param  {string}  password     The password over the login
     * @param  {IEVALoginOptions?} options An optional structure with additional data for the login
     * @return {Promise}              Will resolve when succesfully logged in or rejected with the authentication result (EVA.Core.AuthenticationResults) or a general error
     */
    LoggedInUser.prototype.login = function (login, password, options) {
        var _this = this;
        // EVA.Core.Services.Login
        //
        var service = new service_1.EVAService("Login");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            ApplicationID: settings_1.SettingsManager.getApplicationId()
        };
        // EVA allows users to login using a QR code. This QR code contains
        // an identification code that is all you need to login
        //
        if (options && options.identificationCode) {
            requestData.IdentificationCode = options.identificationCode;
        }
        else {
            // Set the password
            //
            requestData.Password = password;
            requestData.Username = login;
        }
        if (options) {
            if (options.organizationUnitId) {
                requestData.OrganizationUnitID = options.organizationUnitId;
            }
            if (options.confirmationToken) {
                requestData.ConfirmationToken = options.confirmationToken;
            }
            if (options.selectOrganizationByApplicationID) {
                requestData.SelectOrganizationByApplicationID = options.selectOrganizationByApplicationID;
            }
            if (options.publicLogin) {
                requestData.PublicLogin = options.publicLogin;
            }
            if (options.registerApiKey) {
                requestData.RegisterApiKey = options.registerApiKey;
            }
            if (options.context) {
                requestData.Context = options.context;
            }
        }
        return new Promise(function (resolve, reject) {
            service.call(requestData)
                .then(function (serviceResult) {
                _this.setData(serviceResult.response);
                // EVA.Core.AuthenticationResults.
                //  * NotAuthenticated = 0
                //  * NotAuthorized = 1
                //  * Authenticated = 2
                //  * NeedsTwoStepAuthentication = 3
                //  * NeedsOrganizationUnitID = 4
                //
                if (_this.authentication !== 2) {
                    reject(_this.authentication);
                }
                else {
                    resolve(serviceResult);
                }
            })
                .catch(function (error) {
                _this.id = null;
                _this.setData({});
                reject(error);
            });
        });
    };
    /**
     * Switches the organization of the logged in user
     *
     * @param {number} organizationUnitId The new organization id
     * @returns
     * @memberof LoggedInUser
     */
    LoggedInUser.prototype.switchOrganization = function (organizationUnitId) {
        var _this = this;
        // EVA.Core.Services.Login
        //
        var service = new service_1.EVAService("Login");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            ApplicationID: settings_1.SettingsManager.getApplicationId(),
            OrganizationUnitID: organizationUnitId,
            AuthenticationToken: this.authenticationToken
        };
        return new Promise(function (resolve, reject) {
            service.call(requestData)
                .then(function (serviceResult) {
                _this.setData(serviceResult.response);
                // EVA.Core.AuthenticationResults.
                //  * NotAuthenticated = 0
                //  * NotAuthorized = 1
                //  * Authenticated = 2
                //  * NeedsTwoStepAuthentication = 3
                //  * NeedsOrganizationUnitID = 4
                //
                if (_this.authentication !== 2) {
                    reject(_this.authentication);
                }
                else {
                    resolve(serviceResult);
                }
            })
                .catch(function (error) {
                _this.id = null;
                _this.setData({});
                reject(error);
            });
        });
    };
    /**
     * Execute an explicit logout
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.logout = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // EVA.Core.Services.Logout
            //
            var service = new service_1.EVAService("Logout");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {};
            service.call(requestData)
                .then(function (serviceResult) {
                // When the promise is successfully resolved we need to unset our details
                //
                if (!serviceResult.response.LogoutSuccesful) {
                    if (console) {
                        console.warn("Server says logout wasn't successful. Proceeding to clear local session...");
                    }
                }
                // Purge user data
                //
                _this.data = null;
                resolve(serviceResult);
            })
                .catch(reject);
        });
    };
    /**
     * Retrieves third party login options
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.getThirdPartyLoginOptions = function () {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetAvailableThirdPartiesForLogin");
            // Build the request data
            // The base class will add things like SessionID so keep typescript
            // happy we're using an 'any' type object here
            //
            var requestData = {};
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(reject);
        });
    };
    /**
     * Requests third party login.
     * Response will contain a redirect url that can be used to perform the login
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.requestThirdPartyLogin = function (loginRequest) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("RequestThirdPartyLogin");
            service.call(loginRequest)
                .then(function (serviceResult) {
                resolve(serviceResult.response);
            })
                .catch(reject);
        });
    };
    /**
     * Perform third party login with a token
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.authenticateWithThirdPartyLogin = function (loginRequest) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("AuthenticateWithThirdPartyLogin");
            service.call(loginRequest)
                .then(function (serviceResult) {
                _this.authenticationToken = serviceResult.response.AuthenticationToken !== undefined ? serviceResult.response.AuthenticationToken : _this.authenticationToken;
                resolve(serviceResult.response);
            })
                .catch(reject);
        });
    };
    /**
     * This call retrieves a paged list of orders belonging to the current user
     *
     * @param  {number}                         start           The item to start the list at. Defaults to 0 and is a 0-based index.
     * @param  {number}                         limit           The page size limit. Defaults to 15
     * @param  {EVA.Framework.SortDirection}  sortDirection          The sorting direction for the list. Defaults to ascending
     * @return {Promise<customerOrderList>}                     A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.getOrders = function (id, limit, start, sortDirection) {
        var _this = this;
        if (limit === void 0) { limit = 15; }
        if (start === void 0) { start = 0; }
        if (sortDirection === void 0) { sortDirection = 0; }
        return new Promise(function (resolve, reject) {
            var customerOrderList = new orders_1.CustomerOrderList(id, limit, start, sortDirection, "CreationTime");
            customerOrderList.fetch()
                .then(function () {
                _this.orders = customerOrderList;
                resolve(customerOrderList);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    /**
     * This call retrieves a single order
     * @param {number}              order_id                    The ID of the order
     * @param {boolean}             include_failed_payements    If set to true, return order even if the payment has not been completed
     * @return {Promies<Order>}                                 A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.getOrder = function (order_id, include_failed_payements) {
        return new Promise(function (resolve, reject) {
            var service = new service_1.EVAService("GetOrder");
            var requestData = {
                OrderID: order_id,
                IncludeFailedPayments: include_failed_payements
            };
            service.call(requestData)
                .then(function (result) {
                resolve(result.response.Result);
            })
                .catch(function (error) {
                reject(error);
            });
        });
    };
    // /**
    //  * Checks if the user has a newsletter subscription
    //  * @return {boolean} Indicates if the user has a newsletter subscription
    //  */
    // public hasNewsletterSubscription(): boolean
    // {
    //     // SubscriptionType is a bitfield that we need to test
    //     // for value 1 for NewsLetter subscription
    //     //
    //     return this.data !== undefined && ( this.data.SubscriptionType & 1 ) !== 0;
    // }
    // /**
    //  * Subscribes to the Newsletter using the users current email address
    //  * @return {Promise}    A promise resolving when the call to the back-end has completed
    //  */
    // public subscribeToNewsletter(): Promise<IEVAServiceResponse<EVA.Core.Services.Subscribe, EVA.Core.Services.SubscribeToNewsletterResponse>>
    // {
    //     return new Promise( ( resolve: any, reject: any ) =>
    //     {
    //         // Create the service instance
    //         //
    //         var service = new EVAService<EVA.Core.Services.Subscribe, EVA.Core.Services.SubscribeToNewsletterResponse>( "Subscribe" );
    //         // Build the request data
    //         // The base class will add things like SessionID so keep typescript
    //         // happy we're using an 'any' type object here
    //         //
    //         var requestData: any = {
    //             EmailAddress: this.data.EmailAddress,
    //             Type:         1
    //         };
    //         service.call( requestData )
    //         .then( ( serviceResult: IEVAServiceResponse<EVA.Core.Services.Subscribe, EVA.Core.Services.SubscribeToNewsletterResponse> ) =>
    //         {
    //             if ( serviceResult.response.Success === true )
    //             {
    //                 resolve();
    //             }
    //             else
    //             {
    //                 reject( serviceResult );
    //             }
    //         } )
    //         .catch( ( error ) =>
    //         {
    //             reject( error );
    //         } );
    //     } );
    // }
    // /**
    //  * Unsubscribes from the Newsletter using the users current email address
    //  * @return {Promise}    A promise resolving when the call to the back-end has completed
    //  */
    // public unsubscribeFromNewsletter(): Promise<IEVAServiceResponse<EVA.Core.Services.Unsubscribe, EVA.Core.Services.UnsubscribeFromNewsletterResponse>>
    // {
    //     // Create the service instance
    //     //
    //     var service = new EVAService<EVA.Core.Services.Unsubscribe, EVA.Core.Services.UnsubscribeFromNewsletterResponse>( "Unsubscribe" );
    //     // Build the request data
    //     // The base class will add things like SessionID so keep typescript
    //     // happy we're using an 'any' type object here
    //     //
    //     var requestData: any = {
    //         EmailAddress: this.data.EmailAddress,
    //         Type:         1
    //     };
    //     return service.call( requestData );
    // }
    // /**
    //  * Confirms a Newsletter subscription using the provided token
    //  * @param  {string}     token   The subscription confirmation token
    //  * @return {Promise}            A promise resolving when the call to the back-end has completed
    //  */
    // public confirmNewsletterSubscription( token: string ): Promise<IEVAServiceResponse<EVA.Core.Services.ConfirmSubscribe, EVA.Core.Services.ConfirmNewsletterSubscriptionResponse>>
    // {
    //     // Create the service instance
    //     //
    //     var service = new EVAService<EVA.Core.Services.ConfirmSubscribe, EVA.Core.Services.ConfirmNewsletterSubscriptionResponse>( "ConfirmSubscribe" );
    //     // Build the request data
    //     // The base class will add things like SessionID so keep typescript
    //     // happy we're using an 'any' type object here
    //     //
    //     var requestData: any = {
    //         Token:  token,
    //         Type:   1
    //     };
    //     return service.call( requestData );
    // }
    // /**
    //  * Checks if the user has an SMS notification subscription
    //  * @return {boolean} Indicates if the user has an SMS notification subscription
    //  */
    // public hasSmsNotificationSubscription(): boolean
    // {
    //     // SubscriptionType is a bitfield that we need to test
    //     // for value 2 for NewsLetter subscription
    //     //
    //     return this.data !== undefined && ( this.data.SubscriptionType & 2 ) !== 0;
    // }
    // /**
    //  * Subscribes to the SMS Notifications using the users current email address
    //  * @return {Promise}    A promise resolving when the call to the back-end has completed
    //  */
    // public subscribeToSMSNotifications(): Promise<IEVAServiceResponse<EVA.Core.Services.Subscribe, EVA.Core.Services.SubscribeToNewsletterResponse>>
    // {
    //     // Create the service instance
    //     //
    //     var service = new EVAService<EVA.Core.Services.Subscribe, EVA.Core.Services.SubscribeToNewsletterResponse>( "Subscribe" );
    //     // Build the request data
    //     // The base class will add things like SessionID so keep typescript
    //     // happy we're using an 'any' type object here
    //     //
    //     var requestData: any = {
    //         MobileNumber: this.data.PhoneNumber,
    //         Type:         2
    //     };
    //     return service.call( requestData );
    // }
    // /**
    //  * Unsubscribes from the SMS Notifications using the users current email address
    //  * @return {Promise}    A promise resolving when the call to the back-end has completed
    //  */
    // public unsubscribeFromSMSNotifications(): Promise<IEVAServiceResponse<EVA.Core.Services.Unsubscribe, EVA.Core.Services.UnsubscribeFromNewsletterResponse>>
    // {
    //     // Create the service instance
    //     //
    //     var service = new EVAService<EVA.Core.Services.Unsubscribe, EVA.Core.Services.UnsubscribeFromNewsletterResponse>( "Unsubscribe" );
    //     // Build the request data
    //     // The base class will add things like SessionID so keep typescript
    //     // happy we're using an 'any' type object here
    //     //
    //     var requestData: any = {
    //         MobileNumber: this.data.PhoneNumber,
    //         Type:         2
    //     };
    //     return service.call( requestData );
    // }
    /**
     * Update the user
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.update = function () {
        var _this = this;
        var service = new service_1.EVAService("UpdateUser");
        var requestData = __assign({}, this.data);
        return new Promise(function (resolve, reject) {
            service.call(requestData)
                .then(function (serviceResult) {
                _this.setData(serviceResult.response);
                resolve(serviceResult);
            })
                .catch(reject);
        });
    };
    /**
     * Update the user's email address
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.updateUserEmailAddress = function (newEmailAddress) {
        var _this = this;
        var service = new service_1.EVAService("UpdateUserEmailAddress");
        var requestData = {
            ID: this.data.ID,
            NewEmailAddress: newEmailAddress,
        };
        // Update data on success
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData)
                .then(function (serviceResult) {
                _this.setData(serviceResult.response);
                resolve(serviceResult);
            })
                .catch(reject);
        });
    };
    /**
     * Change the passowrd of this user
     *
     * @param  {string}  newPassword The new password
     * @param  {string}  oldPassword The current / old password
     * @return {Promise}             A promise resolving when the call to the back-end has completed
     */
    LoggedInUser.prototype.changePassword = function (newPassword, oldPassword) {
        var service = new service_1.EVAService("ChangeUserPassword");
        var requestData = {
            NewPassword: newPassword,
            OldPassword: oldPassword,
            UserID: this.data.ID
        };
        return new Promise(function (resolve, reject) {
            // Perform the call and capture the resulting promise
            //
            service.call(requestData).then(function (serviceResult) {
                if (serviceResult.response.Success === true) {
                    resolve();
                }
                else {
                    reject(serviceResult.response.Result);
                }
            })
                .catch(reject);
        });
    };
    return LoggedInUser;
}(base_1.FetchableItem));
exports.LoggedInUser = LoggedInUser;
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update the user
     *
     * @return {Promise} A promise resolving when the call to the back-end has completed
     */
    User.prototype.update = function (userDto) {
        var service = new service_1.EVAService("UpdateUser");
        delete userDto.EmailAddress;
        var requestData = __assign({}, userDto);
        return new Promise(function (resolve, reject) {
            service.call(requestData)
                .then(function (serviceResult) {
                resolve(serviceResult);
            })
                .catch(reject);
        });
    };
    /**
     * Retrieves specific user data
     * @return {Promise} A promise that is fulfilled when the EVA Core service responds
     */
    User.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            ID: this.id
        };
        return _super.prototype.fetch.call(this, "GetUser", requestData);
    };
    /**
     * @param  {any}                                  response  Service response containing the user data
     * @return {EVA.Core.UserDto}                   The user data
     */
    User.prototype.setData = function (response) {
        if (response === void 0) { response = {}; }
        // Set the user data
        //
        this.data = response.Result;
        this.isEmployee = this.data && (this.data.Type & 1) !== 0;
        this.isCustomer = this.data && (this.data.Type & 2) !== 0;
        this.isAnonymous = !this.data || (this.data.Type & 4) !== 0;
        return this.data;
    };
    return User;
}(base_1.FetchableItem));
exports.User = User;
